import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  textField: {
    '& .MuiInputBase-root': {
      paddingTop: '10px',
      paddingBottom: '12px',
    },
  },
});
